define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action",
	"csi/action/Controller",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,lang,csiAction,Controller,MessageDialog,xml) {

	return declare(Controller, {
		//_bContinued: false,
		_bPropToSM: null,
		_nWaitForResponse: 500,

		constructor: function(/*Object*/params) {
			// only case to prompt right now is for when making unavailable
			if (this.m_action.m_id == "CMMakeUnavailable") {
				this._bPropToSM = false;
			}
		},

		confirmAction: function(/*Object*/params) {
			// summary: support Yes/No/Cancel
			params.buttons = ["Y","N","C"];
			this.inherited(arguments);
		},

		displayProgressDialog: function(/*Object?*/params) {
			// summary: once process has started and taken a half-second (500 ms), prompt to see if
			// user wants to continue waiting, or would like to interrupt the process and work on something else.
			// If interrupted, mark node as read-only so user cannot repeat action
			this.getNode().$FG |= xml.NODE_FLAG_NOEDIT;

			params.buttons = [MessageDialog.BUTTON_CONTINUE];
			params.onResponse = lang.hitch(this, this._onPublishContinue);

			this.inherited(arguments);
		},

		hasToConfirmAction: function() {
			// summary: prompt if making unavailable
			return this._bPropToSM != null;
		},

		onConfirm: function(/*String*/key) {
			// summary: skip to end if operation cancelled; otherwise continue with processing - if no selected,
			// then do not propagate state change to Sales Market classes
			if (key == "C") {
				this.postProcess();
			} else {
				this._bPropToSM = (key == "Y");
				this.process();
			}
		},

		postProcessSuccess: function() {
			// summary: handle case of refreshing if in state header view or another view (i.e. table)
			if (this.widget.postActionState) {
				this.widget.postActionState(this);
			} else {
				this.widget.postActionRedrawNode(this);
			}
		},

		toWriterRequest: function() {
			// summary: add PropToSM parameter to request if necessary
			var	call = this.inherited(arguments);

			if (this.hasToConfirmAction()) {
				call.addParameter("PropagateToSalesMarkets", xml.ATTR_BOOLEAN, this._bPropToSM);
			}

			return call;
		},

		_onPublishContinue: function() {
			// summary: if Continue button pressed, then act as if action is complete; refresh so
			// that user sees effects of read-only flag (actions disabled)
			if (!this._nPublished) {
				this._bContinued = true;
				this.postProcess(true);
			}
		},

		_onPublishError: function(/*Error*/err) {
			// summary: reset node flag
			this.inherited(arguments);

			var	node = this.getNode();

			if (this.isValidAction() && xml.nodeHasFlag(node, xml.NODE_FLAG_NOEDIT)) {
				node.$FG &= ~xml.NODE_FLAG_NOEDIT;
                this.postProcessSuccess();
			}

			if (this.widget.defView.m_id == "StateHeader" && this.widget.viewParent) {
				this.widget.viewParent.refreshWidget(); //DE28692: Refresh the table of products
			}
		},

		_onPublishResponse: function(/*Response*/response) {
			// summary: if user interrupted progress dialog, then do nothing now
			if (!this._bContinued) {
				this.inherited(arguments);
			}
		}
	});
});